module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "container-blue"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "logo col-sm-2"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("../assets/images/d2logo.png"),
      "alt": "logo"
    }
  })])], 1), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-default col-sm-10"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse nav-menu",
    attrs: {
      "id": "bs-example-navbar-collapse-1"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown hvr-underline-from-center"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    staticClass: "dropdown hvr-underline-from-center"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/charts/daily"
    }
  }, [_vm._v("Daily pollution")])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown hvr-underline-from-center"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, _vm._l((_vm.fetchedData), function(data) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": '/resources' + '/' + data.attributes.slug
      }
    }, [_vm._v(_vm._s(data.attributes.title))])], 1)
  }))]), _vm._v(" "), _c('li', {
    staticClass: "dropdown hvr-underline-from-center"
  }, [_c('router-link', {
    attrs: {
      "to": "/page/about-us"
    }
  }, [_vm._v("\n                      About Us\n                    ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "dropdown hvr-underline-from-center"
  }, [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("\n                      Add My Device\n                    ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "dropdown hvr-underline-from-center"
  }, [_c('router-link', {
    attrs: {
      "to": "/request"
    }
  }, [_vm._v("\n                      Data Request\n                    ")])], 1)]), _vm._v(" "), _vm._m(3)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#bs-example-navbar-collapse-1",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                          Charts "), _c('span', {
    staticClass: "caret"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                      Resources "), _c('span', {
    staticClass: "caret"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header_top"
  }, [_c('div', {
    staticClass: "header_social"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "target": "blank",
      "href": "https://www.facebook.com/drishtikathmandu/?ref=br_rs"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/facebook.jpg"),
      "alt": "fb",
      "width": "9",
      "height": "16"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b0a8ff6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 302
// module chunks = 1